import fetch from 'utils/fetch';

export function addUserConcern(data) {
    return fetch({
        url: '/manage/user/addUserConcern',
        method: 'post',
        data
    });
}
export function addConcernCompany(data) {
    return fetch({
        url: '/manage/user/addConcernCompany',
        method: 'post',
        data
    });
}
export function getUserConcernArea() {
    return fetch({
        url: '/manage/user/getUserConcernArea',
        method: 'post',
    });
}
export function getUserConcernCompany(data) {
    return fetch({
        url: '/manage/user/getUserConcernCompany',
        method: 'post',
        data:data,
    });
}
export function getUserConcernIndustry() {
    return fetch({
        url: '/manage/user/getUserConcernIndustry',
        method: 'post',
    });
}
export function getUserConcernInfo() {
    return fetch({
        url: '/manage/user/getUserConcernInfo',
        method: 'post',
    });
}
export function deleteArea(id) {
    return fetch({
        url: '/manage/user/deleteArea/'+id,
        method: 'get',
    });
}
export function deleteCompany(id) {
    return fetch({
        url: '/manage/user/deleteCompany/'+id,
        method: 'get',
    });
}
export function deleteCompanyByCompanyId(id) {
    return fetch({
        url: '/manage/user/deleteCompanyByCompanyId/'+id,
        method: 'get',
    });
}
export function deleteIndustry(id) {
    return fetch({
        url: '/manage/user/deleteIndustry/'+id,
        method: 'get',
    });
}
export function getDivisionAllow() {
    return fetch({
        url: '/manage/user/getDivisionAllow',
        method: 'get',
    });
}
export function getDivisionJson() {
    return fetch({
        url: '/manage/user/getDivisionJson',
        method: 'get',
    });
}


// WEBPACK FOOTER //
// ./src/api/enuser.js